<template>
    <div>
        <div class="d-flex flex-row justify-content-center align-items-center">
            <img
                :src="inactive.logo_url"
                alt="Stripe"
                class="align-middle h-35px"
            />
            <button class="d-inline btn btn-primary"
                    @click.prevent="createStripeAccount">
                {{ __('sale.add_provider.stripe') }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CreateStripeAccount',

    props: {
        inactive: Object,
    },

    methods: {
        createStripeAccount() {
            axios.post(this.$route('create.stripe.account', {
                storeUuid: this.$page.props.storeUuid,
            })).then(response => {
                window.open(response.data['link'], '_blank')
            }).catch(error => {
                console.error(error)
            })
        },
    },
}
</script>